import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paginacion',
  templateUrl: './paginacion.component.html',
  styleUrls: ['./paginacion.component.scss']
})
export class PaginacionComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  utils: any;
  constructor() {
    this.utils = window.utils;

    this.arrayComponent = [
      {
        id: 'pager-general',
        claseContainer: 'col-6',
        componentRender:
        `
        <nav aria-label="Page navigation example" class="pager-govco">
          <ul class="pagination">
            <li class="page-item"><a class="page-link" href="#">Anterior</a></li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">Siguiente</a></li>
          </ul>
        </nav>
          `,
        titulo: 'Paginador general',
        subtitulo: 'Use un elemento <code>nav</code> para identificarlo como una sección de navegación para examinar lectores y otras tecnologías de asistencia. Además, como es probable que las páginas tengan más de una sección de navegación, es aconsejable proporcionar una descripción aria-label para <code>nav</code> para muestre su propósito. Por ejemplo, si el componente de paginación se usa para navegar entre un conjunto de resultados de búsqueda, podría ser una etiqueta apropiada <code>aria-label="Buscar en paginas de resultados"</code>'
      },
      {
        id: 'pager-states',
        claseContainer: 'col-6',
        componentRender:
        `
        <nav aria-label="Page navigation example" class="pager-govco">
          <ul class="pagination">
            <li class="page-item disabled">
              <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Anterior</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item active" aria-current="page">
              <a class="page-link" href="#">2 <span class="sr-only">(current)</span></a>
            </li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
              <a class="page-link" href="#">Siguiente</a>
            </li>
          </ul>
        </nav>
          `,
        titulo: 'Deshabilitado y estados activos',
        subtitulo: 'Los enlaces de paginación son personalizables para diferentes circunstancias. Use <strong>.disabled</strong> para los enlaces que aparecen sin clic y <strong>.active</strong> para indicar la página actual.'
      },
      {
        id: 'pager-align',
        claseContainer: 'col-12',
        componentRender:
        `
        <nav aria-label="Page navigation example" class="pager-govco">
          <ul class="pagination justify-content-center">
            <li class="page-item disabled">
              <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Anterior</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
              <a class="page-link" href="#">Siguiente</a>
            </li>
          </ul>
        </nav>

        <nav aria-label="Page navigation example" class="pager-govco">
          <ul class="pagination justify-content-end">
            <li class="page-item disabled">
              <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Anterior</a>
            </li>
            <li class="page-item"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item">
              <a class="page-link" href="#">Siguiente</a>
            </li>
          </ul>
        </nav>
          `,
        titulo: 'Alineación',
        subtitulo: 'Cambie la alineación de los componentes de paginación con las utilidades de flexbox.'
      },
    ];

    this.infoComponent = {
      titulo: 'Paginador Gov.co',
      descripcion: 'Documentación y ejemplos para mostrar la paginación para indicar que existe una serie de contenido relacionado en varias páginas. La paginación se crea con elementos HTML de lista para que los lectores de pantalla puedan anunciar la cantidad de enlaces disponibles.'
    }
  }

  ngOnInit() {
    this.utils.init();
  }

  ngAfterViewInit() {
    this.utils.removeTag();
  }
}  